export default "dist/images/components-button-controls-basic.491974a.png";